import * as userActions from '../user/actions';
import * as FOIVBigSubCategoriesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const FOIVBigSubCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOIVBigSubCategoriesActions.SET_FOIV_BIG_SUB_CATEGORIES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case FOIVBigSubCategoriesActions.SET_FOIV_BIG_SUB_CATEGORIES_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case FOIVBigSubCategoriesActions.SET_FOIV_BIG_SUB_CATEGORIES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case FOIVBigSubCategoriesActions.ABORT_FOIV_BIG_SUB_CATEGORIES_REQUEST:
            return initialState;

        case FOIVBigSubCategoriesActions.CLEAN_FOIV_BIG_SUB_CATEGORIES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/FOIVBigSubCategories/reducer.js